module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAO5JREFUWEftlDEOgkAQRYcNrXfwDl7AzsoSag8hs+EEC5N4BntpLSztvYZXsDOsmQQSY1iWXQosZsqFmf94syGBhStZOB8EQAyIATHw/wbqul61bbspy/Ie8tc0xmzTNH0URfEa6/MaIKIDAJwBoEHEfAoEEV0AILPWHrXWp1kAVVXtlFK3bogXog/v3t8j4nUWADcTUQYA/FVcToif8BwRG58x7wr6AT6ImHCePRlgzERseDDAEERniFfENUn791qCDDjW0R8Hh0cZcEBEhc8C4GZjzFop9dZaP3233fU8agWxYUN9AiAGxIAYEAMfJt9WIWip4UkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/newIcon/open.png
// module id = XMGl
// module chunks = 1